import { Applicant } from '../applicant';


export class ApplicantDataSerializer {
    fromJson(json: any): any {
   const data = new Applicant();
        data.id = json.id;
        //data.name =json.lastName? json.firstName + ' ' + json.lastName : json.firstName;
        if(json.lastName){
            data.name= json.firstName + ' ' + json.lastName + ' - ' + transfromPhoneNumber(json.phone);
        }
        else{
            data.name= json.firstName + ' - ' + transfromPhoneNumber(json.phone);
        }
        data.firstName =json.firstName;
        data.lastName=json.lastName;
        data.email=json.email;
        data.phone=json.phone;
        data.fullName=json.lastName? json.firstName + ' ' + json.lastName : json.firstName;
        return data;
    }

    toJson(data: Applicant): any {
        return {
            id: data.id,
            //applicant :data.applicant,
            firstName: data.firstName,
            lastName :data.lastName,
            email:data.email,
            phone :data.phone
        };
    }
}

function transfromPhoneNumber(phone: any) {
    //const countryCodeStr = phone.slice(0,2);
    if(phone){
    const areaCodeStr = phone.slice(0,3);
    const midSectionStr = phone.slice(3,6);
    const lastSectionStr = phone.slice(6);
    return `${areaCodeStr}-${midSectionStr}-${lastSectionStr}`;

    }
    else{
        return "";
    }

}

